import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import Heading from '@/components/typography/Heading'
import { cn } from '@/lib/styles'
import type { GridCardProps } from '@/types/general'
import type { ServerRenderedEntry } from '@/types/helpers'
import styles from './AppsCard.module.css'
import { TileIcon } from './shared/TileIcon'
import { TileLink } from './shared/TileLink'

export function AppsCard({
	icon,
	title,
	description,
	link,
	serverProcessedHtmlDescription,
}: ServerRenderedEntry<GridCardProps>) {
	return (
		<div className="flex flex-col p-4 w-full h-full gap-1">
			<div className="flex flex-col gap-4 w-full">
				{icon?.media?.url && <TileIcon icon={icon} size="small" />}
				{title && (
					<Heading tag="h3" className={cn('text-left w-full', styles['apps-card-title'])}>
						{title}
					</Heading>
				)}
			</div>

			<div className="relative h-full flex flex-col">
				{serverProcessedHtmlDescription ? (
					serverProcessedHtmlDescription
				) : (
					<CkEditorCSRRenderer
						className="group-hover:opacity-0 transition-opacity duration-200"
						variant="textOnly"
						htmlContent={description}
						context="apps-card"
						defaultTypography="bodySmall"
					/>
				)}

				{link && (
					<TileLink
						className="gap-1 absolute top-0 w-full opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity duration-200"
						link={link}
					/>
				)}
			</div>
		</div>
	)
}
